import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

import { JobMatchesQueryFilter } from 'src/app/public/app/models/jobMatchesQueryFilter';
import { FormalizeCandidate, FormalizeCompany, FormalizeRequisition, FormalizeJobMatch } from 'src/app/public/app/models/formalizePayload';
import { CandidatesInfiniteScrollContainer } from './candidates-infinite-scroll-container';

import { AuthService } from 'src/app/core/services/auth.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { RequisitionService } from 'src/app/core/services/requisition.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobService } from 'src/app/core/services/job.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { BrowserService } from 'src/app/core/services/browser.service';
import { OutreachService } from 'src/app/core/services/outreach.service';
import { StateManagementStorageService } from 'src/app/core/services/state-management-storage.service';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { CandidateJobMatchesWorkflowActionsModalComponent } from '../candidate-job-matches-workflow-actions-modal/candidate-job-matches-workflow-actions-modal.component';
import { JobMatchDragAndDropService } from 'src/app/core/services/job-match-drag-and-drop.service';
import { CandidateSendOutreachEmailModalComponent } from '../candidate-send-outreach-email-modal/candidate-send-outreach-email-modal.component';
import { WebSocketsService } from 'src/app/core/services/web-sockets.service';

declare var $: any;

@Component({
  selector: 'app-candidate-job-matches-workflow',
  templateUrl: './candidate-job-matches-workflow.component.html',
  styleUrls: ['./candidate-job-matches-workflow.component.css']
})
export class CandidateJobMatchesWorkflowComponent implements OnInit, OnDestroy {

  @Input() jobId: any;
  @Input() searchString: any;
  @Input() globalQueryFilterObject: any;
  @Input() reqStateData: any;

  companyId: any;
  isCorporateFlag = false;
  isStaffingFlag = false;
  userId: any;
  candidatesObject: any = {};
  enabledWorkflowSteps: any = {};
  workflowStepNames: any[] = [];
  activityMap: any[] = [];
  jobMatchStates: any[] = [];
  jobMatchStateOptions: any[] = [];
  vendorsList: any[] = [];
  selectedJobMatchStates: any[] = [];
  selectedVendors: any[] = [];
  salaryDurationOptions: any[] = [];
  requisitionStatusesToDisableAddActions = ['Sourced', 'Paused', 'Canceled', 'Completed'];
  jobInfo: any = {};
  requisitionStatus = '';
  hiringManagersList: any[] = [];
  allJobMatches: any[] = [];
  countOfCandidatesWhoseStepHasChangedInBackground = 0;
  candidatesStepChangedInBackgroundMessage = '';
  assessmentDetails: any = null;
  valueAssessmentDetails: any = null;
  displaySelectedFilterContainer: any = {};
  savedFilters: any = null;
  savedDisplayedWorkflowSelectedFilter: any = null;
  candidateWorkFlowFilterItemsSelected: any[] = [];
  primaryHiringManager: any[] = [];
  endClient: any = null;
  outreachFilters: any[] = [];
  selectedOutreachStates: any[] = [];
  workflowFirstStep = '';
  pointOfContact: any;
  headerInfo: any;
  companyLabel: any;
  locationLabel: any;
  jobLocation: any;
  jobTypeList: any[] = [];
  displaySelectedFilterObj: any = {};
  deleteSelectedFilter: any = {};
  skeletonPlaceholders = Array(3).fill(0);

  // flags
  isFiltersChanged = false;
  showFilterPanel = false;
  isSuperUserOr4dot5Admin = false;
  showRefreshWorkFlowAction = false;
  hideSearchStringFlag = false;
  jobIntegrationEnabled = false;
  disableAddActionsFlag = false;
  disableAssignRecruiterActionsFlag = false;
  disableSendTechAssessmentActionsFlag = false;
  disableValueAssessmentActionsFlag = false;
  disableCancelTechAssessmentActionsFlag = false;
  disableCancelValueAssessmentActionsFlag = false;
  disableReleaseCandidatesActionsFlag = false;
  disableMarkAsNotInterestedActionsFlag = false;
  jobInfoLoadedFlag = false;
  isJobBoardServiceUp = true;
  jobMatchStatesLoadedFlag = false;
  showVendorFilterFlag = false;
  vendorsListLoadedFlag = false;
  showGlobalAssignRecruiterAction = true;
  showGlobalTechAssessmentAction = false;
  showGlobalCancelTechAssessmentAction = false;
  showGlobalValueAssessmentAction = false;
  showGlobalCancelValueAssessmentAction = false;
  enableSelectJobMatchesOptions = false;
  selectAllJobMatchesFlag = false;
  techAssessmentInfoLoading = true;
  valueAssessmentInfoLoading = true;
  isTechAssessmentInfoExists = false;
  isValueAssessmentInfoExists = false;
  displayCandidateWorkFlowFilter = false;
  showDisplayFilterIcon = true;
  emptyJobMatchSelectedFilter = false;
  isRecruitersPopoverOpen = false;
  isHiringManagerPopoverOpen = false;
  isOutreachEnabled = false;
  refreshReRunScore = false;
  scoringInProgress = false;
  outreachFiltersLoadedFlag = false;
  jobMatchInProgress = false;

  private refreshJobWorkflowSubscription!: Subscription;
  private removeJobMatchSubscription!: Subscription;
  private queryJobMatchesDebounced: () => void;
  private workflowUpdateSubscription!: Subscription;

  constructor(
    public $state: StateService,
    @Inject(WebSocketsService) private webSocketsService: WebSocketsService,
    private jobMatchDragAndDropService: JobMatchDragAndDropService,
    private authService: AuthService,
    private assessmentService: AssessmentService,
    private requisitionService: RequisitionService,
    private companyService: CompanyService,
    private jobMatchService: JobMatchService,
    private jobService: JobService,
    private planService: PlanService,
    private userRoleService: UserRoleService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private browserService: BrowserService,
    private outreachService: OutreachService,
    private stateManagementStorageService: StateManagementStorageService,
    private bsModalService: BsModalService,
    private modalService: AngularModalService
  ) { }

  ngOnInit() {
    const userDetails = this.authService.getUserDetails();
    this.companyId = userDetails.company.companyId;
    this.isCorporateFlag = this.companyService.isCorporateCompany();
    this.isStaffingFlag = this.companyService.isStaffingCompany();
    this.userId = userDetails.id;

    this.candidatesObject = {};
    this.enabledWorkflowSteps = {};
    this.workflowStepNames = [];
    this.activityMap = [];
    this.jobMatchStates = [];
    this.vendorsList = [];
    this.selectedJobMatchStates = [];
    this.selectedVendors = [];
    this.salaryDurationOptions = [];
    this.jobInfo = {};
    this.requisitionStatus = '';
    this.hiringManagersList = [];
    this.allJobMatches = [];
    this.countOfCandidatesWhoseStepHasChangedInBackground = 0;
    this.candidatesStepChangedInBackgroundMessage = '';
    this.assessmentDetails = null;
    this.valueAssessmentDetails = null;
    this.displaySelectedFilterContainer = {};
    this.displaySelectedFilterContainer.searchString = '';
    this.displaySelectedFilterContainer.jobMatchStates = [];
    this.displaySelectedFilterContainer.vendors = [];
    this.displaySelectedFilterContainer.outreachStateFilters = [];
    this.savedFilters = null;
    this.savedDisplayedWorkflowSelectedFilter = null;

    const savedFilters = this.stateManagementStorageService.getScreenState(`candidateWorkflowScreen-${this.userId}`);
    if (savedFilters && !_.isEmpty(savedFilters)) {
      savedFilters.jobMatchIds = [];
      this.savedFilters = _.cloneDeep(savedFilters);
    } else {
      this.savedFilters = this.globalQueryFilterObject;
    }
    const filter = _.cloneDeep(this.displaySelectedFilterContainer);
    const savedDisplayedWorkflowSelectedFilter = this.stateManagementStorageService.getScreenState(`candidateWorkflowScreen-displayFilter-${this.userId}`);
    if (savedDisplayedWorkflowSelectedFilter && !_.isEmpty(savedDisplayedWorkflowSelectedFilter)) {
      this.displaySelectedFilterContainer = _.cloneDeep(savedDisplayedWorkflowSelectedFilter);
      this.savedDisplayedWorkflowSelectedFilter = _.cloneDeep(savedDisplayedWorkflowSelectedFilter);
    } else {
      this.stateManagementStorageService.setScreenState(`candidateWorkflowScreen-displayFilter-${this.userId}`, filter);
    }
    this.candidateWorkFlowFilterItemsSelected = [];
    this.primaryHiringManager = [];
    this.endClient = null;
    this.outreachFilters = [];
    this.selectedOutreachStates = [];
    this.workflowFirstStep = '';

    this.isFiltersChanged = false;
    this.showFilterPanel = false;
    this.isSuperUserOr4dot5Admin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
    this.showRefreshWorkFlowAction = false;
    this.hideSearchStringFlag = false;
    this.jobIntegrationEnabled = false;
    this.disableAddActionsFlag = false;
    this.disableAssignRecruiterActionsFlag = false;
    this.disableSendTechAssessmentActionsFlag = false;
    this.disableValueAssessmentActionsFlag = false;
    this.disableCancelTechAssessmentActionsFlag = false;
    this.disableCancelValueAssessmentActionsFlag = false;
    this.disableReleaseCandidatesActionsFlag = false;
    this.disableMarkAsNotInterestedActionsFlag = false;
    this.jobInfoLoadedFlag = false;
    this.isJobBoardServiceUp = true;
    this.jobMatchStatesLoadedFlag = false;
    this.showVendorFilterFlag = false;
    this.vendorsListLoadedFlag = false;
    this.showGlobalAssignRecruiterAction = true;
    this.showGlobalTechAssessmentAction = false;
    this.showGlobalCancelTechAssessmentAction = false;
    this.showGlobalValueAssessmentAction = false;
    this.showGlobalCancelValueAssessmentAction = false;
    this.enableSelectJobMatchesOptions = false;
    this.selectAllJobMatchesFlag = false;
    this.techAssessmentInfoLoading = true;
    this.valueAssessmentInfoLoading = true;
    this.isTechAssessmentInfoExists = false;
    this.isValueAssessmentInfoExists = false;
    this.displayCandidateWorkFlowFilter = false;
    this.showDisplayFilterIcon = true;
    this.emptyJobMatchSelectedFilter = false;
    this.isRecruitersPopoverOpen = false;
    this.isHiringManagerPopoverOpen = false;
    this.isOutreachEnabled = false;
    this.refreshReRunScore = false;
    this.scoringInProgress = false;
    this.outreachFiltersLoadedFlag = false;
    this.jobMatchInProgress = false;

    setTimeout(() => {
      this._setDragConfig();
    }, 2000);

    this.getOutreachFilters();
    this._setDebounceService();
    this._listenToWorkflowStateUpdate();
    this._listenToJobMatchRemove();
    this._getAllActivityTypes();
    this._getAllJobMatchStates();
    this._getPlanDetails();
    this._getSalaryDurationOptions(() => {
      this._getJobDetails(() => {
        this.requisitionStatus = this.jobInfo.requisitionStatus;
        if (this.jobInfo.hiringManagerDetails && this.jobInfo.hiringManagerDetails.length > 0) {
          if (this.jobInfo.hiringManagerDetails.length === 1) {
            this.primaryHiringManager = this.jobInfo.hiringManagerDetails;
          } else {
            this.jobInfo.hiringManagerDetails.map((hiringManager: any) => {
              if (hiringManager.isPrimary || hiringManager.isPoc) {
                this.primaryHiringManager.push(hiringManager);
              } else {
                this.hiringManagersList.push(hiringManager);
              }
            });
          }

          if (this.primaryHiringManager.length === 0) {
            this.primaryHiringManager = this.hiringManagersList.slice(1);
          }
        }
        this.pointOfContact = this.jobInfo.pointOfContact;
        this.endClient = this.jobInfo.endClient ? this.jobInfo.endClient.name : this.jobInfo.endClient;
        if (this.requisitionStatusesToDisableAddActions.indexOf(this.requisitionStatus) !== -1) {
          this.disableAddActionsFlag = true;
        }
        if (this.isCorporateFlag && this.jobInfo.sharedRequisition) {
          this.showGlobalAssignRecruiterAction = false;
          this.showVendorFilterFlag = true;
          this._getVendors();
        }

        if (this.jobId !== '') {
          this.getEnabledWorkflowSteps(() => {
            _.forEach(this.enabledWorkflowSteps, (val: any) => {
              if (val === 'Tech Assessment') {
                this.showGlobalTechAssessmentAction = true;
                this.showGlobalCancelTechAssessmentAction = true;
              } else if (val === 'Value Assessment') {
                this.showGlobalValueAssessmentAction = true;
                this.showGlobalCancelValueAssessmentAction = true;
              }
            });
            this._createCandidatesObject();
            this._loadAllCandidateColumns();
          });
        } else {
          this._createCandidatesObject();
          this._loadAllCandidateColumns();
        }

        this.refreshJobWorkflowSubscription = this.jobMatchService.refreshJobWorkflow.subscribe(() => {
          this.resetCandidateJobMatches();
        });

        this.jobInfo.listOfAllRecruitersAndHiringManagers = [...(this.jobInfo.allRecruitersList || []), ...this.hiringManagersList, ...this.primaryHiringManager];
        if (this.pointOfContact) {
          this.jobInfo.listOfAllRecruitersAndHiringManagers = this.jobInfo.listOfAllRecruitersAndHiringManagers.filter((user: any) => user.name !== this.pointOfContact);
          this.jobInfo.listOfAllRecruitersAndHiringManagers.push({ name: this.pointOfContact });
        }
      });
    });
    this._checkJobBoardsSearchAvailability();

    $(document).ready(() => {
      $('#workflow-search-panel').hide();
      $(document).off('click', '#open-filter').on('click', '#open-filter', () => {
        $('#workflow-search-panel').animate({ height: 'toggle' });
        this.showFilterPanel = !this.showFilterPanel;
      });
    });
    this.getAllPreferredJobTypes();
    this._checkIfOutreachEnabled();
    this.getJobScoringJobStatus();
  }

  getJobScoringJobStatus() {
    this.jobService.getJobScoringJobStatus(this.jobId, (data: any) => {
      this.scoringInProgress = data;
      if (this.scoringInProgress) {
        const message = "Job matching is in progress. You will be notified once it's completed...";
        this.alertsAndNotificationsService.showAlertWithCallBack('Job matching in Progress', message, 'success', () => {
          this.$state.go('missioncontrol.requisitions');
        });
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _checkTechAssessmentIdExists() {
    if (this.jobInfo.techAssessmentId) {
      this.isTechAssessmentInfoExists = true;
    }
  }

  _getAssessmentDetails() {
    if (this.assessmentDetails === null) {
      this.assessmentService.getAssessmentDetails(this.jobInfo.techAssessmentId, this.jobId, (data: any) => {
        this.assessmentDetails = data;
        this._setTotalDuration();
        this.techAssessmentInfoLoading = false;
      }, () => {
        // do nothing
      });
    }
  }

  private _setTotalDuration() {
    this.assessmentDetails.totalDuration = 0;
    _.forEach(this.assessmentDetails.sections, (section: any) => {
      this.assessmentDetails.totalDuration = this.assessmentDetails.totalDuration + section.duration;
    });
  }

  private _checkValueAssessmentIdExists() {
    if (this.jobInfo.valueAssessmentId) {
      this.isValueAssessmentInfoExists = true;
    }
  }

  _getValueAssessmentDetails() {
    if (this.jobInfo.valueAssessmentId != null && this.valueAssessmentDetails === null) {
      this.assessmentService.getAssessmentDetails(this.jobInfo.valueAssessmentId, this.jobId, (data: any) => {
        this.valueAssessmentDetails = data;
        this._setValueAssessmentDuration();
        this.valueAssessmentInfoLoading = false;
      }, () => {
        // do nothing
      });
    }
  }

  private _setValueAssessmentDuration() {
    this.valueAssessmentDetails.totalDuration = 0;
    _.forEach(this.valueAssessmentDetails.sections, (section: any) => {
      this.valueAssessmentDetails.totalDuration = this.valueAssessmentDetails.totalDuration + section.duration;
    });
  }

  private _massageRequisitionCardInfo(data: any) {
    const massagedRequisitionInfo = this.requisitionService.massageRequisitionCardInfo(data, this.salaryDurationOptions);
    _.merge(this.jobInfo, massagedRequisitionInfo.data);
  }

  onGlobalFilterChange(event?: any) {
    this.isFiltersChanged = true;
    if (!this.showFilterPanel) {
      $('#workflow-search-panel').animate({ height: 'toggle' });
      this.showFilterPanel = true;
    }

    if (this._onEnterKeyPress(event)) {
      (this.queryJobMatchesDebounced || this.queryJobMatches.bind(this))();
    }
  }

  private _onEnterKeyPress(event: any) {
    return event && event.keyCode === 13;
  }

  private _setDragConfig() {
    // Drag-and-drop scroll auto-panning is handled via Angular CDK drag-drop (cdkScrollable)
    // in the template; explicit jQuery-based scroll handlers are not required with CDK.
  }

  private _setDebounceService() {
    this.queryJobMatchesDebounced = _.debounce(this.queryJobMatches.bind(this), 500);
  }

  private _listenToWorkflowStateUpdate() {
    this.workflowUpdateSubscription = this.webSocketsService.receiveWorkflowUpdate().subscribe((stateChange: any) => {
      if (this.jobId === stateChange.reqId) {
        this.jobMatchInProgress = stateChange.jobMatchInProgress;
      }

      if (stateChange.refreshWorkflow && this.jobId === stateChange.reqId) {
        if (stateChange.reRunScoringDone) {
          this.showRefreshWorkFlowAction = true;
          this.refreshReRunScore = true;
          this.candidatesStepChangedInBackgroundMessage = 'Re-run for candidates in workflow done.';
        } else {
          if (!stateChange.jobMatchInProgress) {
            this.showRefreshWorkFlowAction = true;
            this.refreshReRunScore = false;
            this.countOfCandidatesWhoseStepHasChangedInBackground++;
            if (this.countOfCandidatesWhoseStepHasChangedInBackground === 1) {
              this.candidatesStepChangedInBackgroundMessage = ' Card updated.';
            } else {
              this.candidatesStepChangedInBackgroundMessage = ' Cards updated.';
            }
          }
        }
      }
      this.jobMatchService.requestJobMatchCardRefresh(stateChange);
    });
  }

  private _listenToJobMatchRemove() {
    this.removeJobMatchSubscription = this.jobMatchService.removeJobMatchCard.subscribe((jobMatch: any) => {
      this.resetCandidateJobMatches();
      let candidateName = jobMatch.firstName;
      if (jobMatch.lastName) {
        candidateName += ' ' + jobMatch.lastName;
      }
      const message = `${candidateName} has been removed as the candidate no longer matches the job requirements`;
      this.alertsAndNotificationsService.showAlert('Job Match Removed', message, 'warning');
    });
  }

  private _getAllActivityTypes() {
    this.jobService.getActivityTypes((data: any) => {
      this.activityMap = [];
      _.forEach(data, (val: any) => {
        this.activityMap[val.value] = val.name;
      });
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _getAllJobMatchStates() {
    this.jobMatchStatesLoadedFlag = false;
    this.jobMatchService.getAllJobMatchStates((data: any) => {
      _.forEach(data.candidateWorkflowCardStatus, (stepVal: any) => {
        _.forEach(stepVal.states, (stateVal: any) => {
          const stateEntry: any = {};
          stateEntry.name = stateVal;
          stateEntry.value = stateVal;
          if (stateVal === 'No longer a match') {
            stateEntry.label = "<span style='color: #e84e40;'>" + stateVal + '</span>';
          } else {
            stateEntry.label = stateVal;
          }
          stateEntry.stepGroup = stepVal.status;
          stateEntry.ticked = false;
          this.jobMatchStates.push(stateEntry);
        });
      });
      this.jobMatchStateOptions = this.jobMatchStates.filter(state => !!state.value);
      this.jobMatchStatesLoadedFlag = true;

      if (this.savedFilters && this.savedFilters.workflowStates && this.savedFilters.workflowStates.length > 0) {
        this.selectedJobMatchStates = this.jobMatchStates.filter(jobMatch => jobMatch.value && this.savedFilters.workflowStates.some((selected: any) => selected === jobMatch.value));
        this.selectedJobMatchStates.forEach(state => state.ticked = true);
        this.globalQueryFilterObject.workflowStates = this.selectedJobMatchStates.map((val: any) => val.value);
      }

      if (this.savedDisplayedWorkflowSelectedFilter && this.savedDisplayedWorkflowSelectedFilter.jobMatchStates && this.savedDisplayedWorkflowSelectedFilter.jobMatchStates.length !== 0) {
        this.displaySelectedFilterContainer.jobMatchStates = [];
        this.displaySelectedFilterContainer.jobMatchStates = this.selectedJobMatchStates.map((val: any) => val.value);
        this.setSelectedFilterItems(this.displaySelectedFilterContainer);
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _getPlanDetails() {
    this.planService.getCompanyPlanDetails(this.companyId, (data: any) => {
      if (data !== null && typeof data === 'object' && data.features !== null && data.features.length) {
        const jobIntegrationDetails = _.find(data.features, { name: 'Job Board Integration', available: true });
        this.jobIntegrationEnabled = jobIntegrationDetails !== undefined;
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _getSalaryDurationOptions(successCallback: () => void) {
    this.jobService.getSalaryDurationOptions((data: any) => {
      this.salaryDurationOptions = data;
      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _getJobDetails(successCallback: () => void) {
    this.jobInfoLoadedFlag = false;
    this.jobService.getRequisitionDetails(this.jobId, this.companyId, (data: any) => {
      _.merge(this.jobInfo, data);
      this._massageRequisitionCardInfo(this.jobInfo);
      this._checkTechAssessmentIdExists();
      this._checkValueAssessmentIdExists();
      this.headerInfo = this._getHeaderInfo();
      const headerDetailsList = this.headerInfo.split('@');
      if (headerDetailsList && headerDetailsList.length > 0) {
        this.companyLabel = headerDetailsList[0];
        if (headerDetailsList.length > 1) {
          this.locationLabel = headerDetailsList[1];
        }
      } else {
        this.companyLabel = this.headerInfo;
      }
      this.jobInfoLoadedFlag = true;
      this._setGlobalActionsPermission();
      this.jobMatchInProgress = data.jobMatchInProgress;
      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _getHeaderInfo() {
    const info = this.jobService.getJobLocationInfoText(this.jobInfo, this.isCorporateFlag);
    this.jobLocation = info.jobLocation;
    return info.headerInfo;
  }

  private _setGlobalActionsPermission() {
    if (this.jobInfo.requisitionStatus === 'Paused' || this.jobInfo.requisitionStatus === 'Canceled') {
      this.disableAssignRecruiterActionsFlag = true;
      this.disableSendTechAssessmentActionsFlag = true;
      this.disableValueAssessmentActionsFlag = true;
      this.disableCancelTechAssessmentActionsFlag = true;
      this.disableCancelValueAssessmentActionsFlag = true;
      this.disableReleaseCandidatesActionsFlag = true;
      this.disableMarkAsNotInterestedActionsFlag = true;
    }
  }

  private _getVendors() {
    this.vendorsListLoadedFlag = false;
    this.jobService.getAssignedVendors(this.jobId, (data: any) => {
      this.vendorsList = data;

      if (this.savedFilters && this.savedFilters.vendors && this.savedFilters.vendors.length > 0) {
        this.selectedVendors = this.vendorsList.filter(vendor => this.savedFilters.vendors.some((selected: any) => selected === vendor.vendorId));
        this.selectedVendors.forEach(vendor => vendor.ticked = true);
        this.globalQueryFilterObject.vendors = this.selectedVendors.map((val: any) => val.vendorId);
      }

      if (this.savedDisplayedWorkflowSelectedFilter && this.savedDisplayedWorkflowSelectedFilter.vendors && this.savedDisplayedWorkflowSelectedFilter.vendors.length !== 0) {
        this.displaySelectedFilterContainer.vendors = [];
        this.displaySelectedFilterContainer.vendors = this.selectedVendors.map((val: any) => val.vendorName);
        this.setSelectedFilterItems(this.displaySelectedFilterContainer);
      }

      this.vendorsListLoadedFlag = true;
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getEnabledWorkflowSteps(successCallback: () => void) {
    this.jobService.getEnabledWorkflowSteps(this.jobId, (data: any) => {
      this.enabledWorkflowSteps = data;
      this.workflowStepNames = [];
      _.forEach(this.enabledWorkflowSteps, (stepName: any) => {
        this.workflowStepNames.push(stepName);
      });
      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _createCandidatesObject() {
    this.candidatesObject = {};
    if (this.jobId !== '') {
      _.forEach(this.enabledWorkflowSteps, (val: any) => {
        const tempVal = val;
        const infoVariableStringArray = tempVal.split(' ');
        let infoVariableString = '';
        let identifierString = '';
        if (infoVariableStringArray.length > 1) {
          infoVariableString = infoVariableStringArray[0].toLowerCase() + infoVariableStringArray[1] + 'Info';
          identifierString = infoVariableStringArray[0].toLowerCase() + '-' + infoVariableStringArray[1].toLowerCase();
        } else {
          infoVariableString = infoVariableStringArray[0].toLowerCase() + 'Info';
          identifierString = infoVariableStringArray[0].toLowerCase();
        }
        this.candidatesObject[infoVariableString] = new CandidatesInfiniteScrollContainer(val, infoVariableString, identifierString, this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService);
      });
    } else {
      this.candidatesObject = {
        recruiterScreeningInfo: new CandidatesInfiniteScrollContainer('Recruiter Screening', 'recruiterScreeningInfo', 'recruiter-screening', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
        techAssessmentInfo: new CandidatesInfiniteScrollContainer('Tech Assessment', 'techAssessmentInfo', 'tech-assessment', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
        valueAssessmentInfo: new CandidatesInfiniteScrollContainer('Value Assessment', 'valueAssessmentInfo', 'value-assessment', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
        verificationInfo: new CandidatesInfiniteScrollContainer('Verification', 'verificationInfo', 'verification', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
        phoneScreenInfo: new CandidatesInfiniteScrollContainer('Phone Screen', 'phoneScreenInfo', 'phone-screen', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
        interviewInfo: new CandidatesInfiniteScrollContainer('Interview', 'interviewInfo', 'interview', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
        notInterestedInfo: new CandidatesInfiniteScrollContainer('Not Interested', 'notInterestedInfo', 'not-interested', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
        releasedInfo: new CandidatesInfiniteScrollContainer('Released', 'releasedInfo', 'released', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService)
      };
    }

    setTimeout(() => {
      const first: any = Object.values(this.candidatesObject)[0];
      if (first) {
        this.workflowFirstStep = first.workflowStepNames[0];
      }
    }, 500);
  }

  private _loadAllCandidateColumns() {
    _.forEach(this.candidatesObject, (val: any) => {
      val.getNext();
    });
  }

  resetCandidateJobMatches() {
    this.showRefreshWorkFlowAction = false;
    this.refreshReRunScore = false;
    this.countOfCandidatesWhoseStepHasChangedInBackground = 0;
    this._createCandidatesObject();
    _.forEach(this.candidatesObject, (val: any) => {
      const tempWorkflowSteps = val.jobMatchesQueryFilter.workflowSteps;
      val.jobMatchesQueryFilter = _.cloneDeep(this.globalQueryFilterObject);
      val.jobMatchesQueryFilter.workflowSteps = tempWorkflowSteps;
      this._clearJobMatchIdsFilterOnAnyOtherFilterChange(val.jobMatchesQueryFilter);
      val.getNext();
    });
  }

  private _clearJobMatchIdsFilterOnAnyOtherFilterChange(jobMatchesQueryFilter: any) {
    jobMatchesQueryFilter.jobMatchIds = [];
  }

  selectAllCandidates() {
    this.selectAllJobMatchesFlag = true;
    const selectingAllCandidatesDialog = this.alertsAndNotificationsService.showLoadingDialog('Selecting Candidates');
    this._getAllJobMatches(() => {
      _.forEach(this.candidatesObject, (val: any) => {
        _.forEach(val.candidates, (candidate: any) => {
          candidate.selectedFlag = true;
        });
      });
      selectingAllCandidatesDialog.modal('hide');
    });
  }

  private _getAllJobMatches(successCallback: () => void) {
    const steps: any[] = [];
    _.forEach(this.enabledWorkflowSteps, (step: any) => {
      steps.push(step);
    });

    const jobMatchesQueryFilter = _.cloneDeep(this.globalQueryFilterObject);
    jobMatchesQueryFilter.workflowSteps = _.cloneDeep(steps);
    this.jobMatchService.getJobMatchCandidates(this.userId, this.companyId, 1, 2000, this.jobId, jobMatchesQueryFilter, (data: any) => {
      this.allJobMatches = [];
      _.forEach(this.enabledWorkflowSteps, (val: any) => {
        const tempVal = val;
        const infoVariableStringArray = tempVal.split(' ');
        let infoVariableString = '';
        if (infoVariableStringArray.length > 1) {
          infoVariableString = infoVariableStringArray[0].toLowerCase() + infoVariableStringArray[1] + 'Info';
        } else {
          infoVariableString = infoVariableStringArray[0].toLowerCase() + 'Info';
        }
        const tempJobMatches = JSON.parse(data[infoVariableString]);
        _.forEach(tempJobMatches, (jobMatch: any) => {
          jobMatch.selectFlag = false;
          this.allJobMatches.push(jobMatch);
        });
      });
      this.enableSelectJobMatchesOptions = true;
      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllPreferredJobTypes() {
    this.jobService.getAllJobTypes((data: any) => {
      this.jobTypeList = data;
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _checkIfOutreachEnabled() {
    this.isOutreachEnabled = true;
  }

  deSelectAllCandidates() {
    this.selectAllJobMatchesFlag = false;
    _.forEach(this.candidatesObject, (val: any) => {
      _.forEach(val.candidates, (candidate: any) => {
        candidate.selectedFlag = false;
      });
    });
  }

  private _checkJobBoardsSearchAvailability() {
    this.jobService.checkJobBoardsSearchAvailability((data: any) => {
      this.isJobBoardServiceUp = data;
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  displaySelectedFilterToggle() {
    if (this.displayCandidateWorkFlowFilter) {
      $('#display-candidate-workflow-selected-filter-panel').animate({ height: 'toggle' });
      this.showDisplayFilterIcon = !this.showDisplayFilterIcon;
    }
  }

  addToDisplayFilters(event: string) {
    switch (event) {
      case 'search':
        this.displaySelectedFilterContainer.searchString = this.globalQueryFilterObject.searchString;
        this.setSelectedFilterItems(this.displaySelectedFilterContainer);
        break;
      default:
        break;
    }
  }

  private _setObjectVariableName(currentObject: any) {
    const selectedFilterVariableNameObj: any = {
      jobMatchStates: 'Job Match States', vendors: 'Vendors', searchString: 'Search', outreachStateFilters: 'Outreach States'
    };

    for (const key in selectedFilterVariableNameObj) {
      if (selectedFilterVariableNameObj.hasOwnProperty(key)) {
        const obj = selectedFilterVariableNameObj[key];
        if (key === currentObject.variable) {
          this.displaySelectedFilterObj.variable = obj;
        }
      }
    }
  }

  isFilterValueArray(value: any) {
    return Array.isArray(value);
  }

  setSelectedFilterItems(filtersItemsSelected: any) {
    this.emptyJobMatchSelectedFilter = false;
    for (const key in filtersItemsSelected) {
      if (filtersItemsSelected.hasOwnProperty(key)) {
        const obj = filtersItemsSelected[key];
        if (obj.length > 0) {
          this.displayCandidateWorkFlowFilter = true;
          this.displaySelectedFilterObj = {};

          if (this.candidateWorkFlowFilterItemsSelected.length !== 0) {
            this.candidateWorkFlowFilterItemsSelected.forEach((filterItem: any) => {
              if (filterItem.filter === key) {
                if (filterItem.setSelectedFilterLimit === 5) {
                  this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                } else {
                  this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter };
                }
              }
            });
          }

          if (this.candidateWorkFlowFilterItemsSelected.length === 0 || Object.keys(this.displaySelectedFilterObj).length === 0) {
            this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
          }

          this._setObjectVariableName(this.displaySelectedFilterObj);

          if (this.candidateWorkFlowFilterItemsSelected.length > 0) {
            this.candidateWorkFlowFilterItemsSelected = this.candidateWorkFlowFilterItemsSelected.filter(item => item.variable !== this.displaySelectedFilterObj.variable);
          }
          this.candidateWorkFlowFilterItemsSelected.push(this.displaySelectedFilterObj);
        } else {
          if (this.candidateWorkFlowFilterItemsSelected.length > 0) {
            this.candidateWorkFlowFilterItemsSelected = this.candidateWorkFlowFilterItemsSelected.filter(item => item.filter !== key);
          }
        }
      }
    }
    if (this.candidateWorkFlowFilterItemsSelected.length === 0) {
      if (this.candidatesObject && this.candidatesObject.notInterestedInfo && !this.candidatesObject.notInterestedInfo.isFilterOn) {
        this.displayCandidateWorkFlowFilter = false;
      } else {
        this.emptyJobMatchSelectedFilter = true;
      }
    }
  }

  private _deleteSelectedItem(currentObject: any, filtersItemsDeleted: any) {
    switch (currentObject.variable) {
      case 'searchString':
        this.globalQueryFilterObject.searchString = '';
        this.displaySelectedFilterContainer.searchString = '';
        this.setSelectedFilterItems(this.displaySelectedFilterContainer);
        break;
      case 'jobMatchStates':
        this.jobMatchStates.forEach((jobMatch: any) => {
          if (jobMatch.value === filtersItemsDeleted) {
            jobMatch.ticked = false;
            this.selectedJobMatchStates = this.selectedJobMatchStates.filter(item => item.value !== filtersItemsDeleted);
          }
        });
        this.onFilterItemClick(null, 'JobMatchStates');
        break;
      case 'vendors':
        this.vendorsList.forEach((vendor: any) => {
          if (vendor.vendorName === filtersItemsDeleted) {
            vendor.ticked = false;
            this.selectedVendors = this.selectedVendors.filter(item => item.vendorName !== filtersItemsDeleted);
          }
        });
        this.onFilterItemClick(null, 'Vendors');
        break;
      case 'outreachStateFilters':
        this.outreachFilters.forEach((outreachState: any) => {
          if (outreachState.name === filtersItemsDeleted) {
            outreachState.ticked = false;
            this.selectedOutreachStates = this.selectedOutreachStates.filter(item => item.name !== filtersItemsDeleted);
          }
        });
        this.onFilterItemClick(null, 'OutreachStates');
        break;
      default:
        break;
    }
  }

  deletedSelectedFilterItem(filtersItemsDeleted: any) {
    for (const key in this.displaySelectedFilterContainer) {
      if (this.displaySelectedFilterContainer.hasOwnProperty(key)) {
        const obj = this.displaySelectedFilterContainer[key];
        if (Array.isArray(obj)) {
          if (obj.includes(filtersItemsDeleted)) {
            this.deleteSelectedFilter = { variable: key, value: obj };
            this._deleteSelectedItem(this.deleteSelectedFilter, filtersItemsDeleted);
          }
        } else {
          if (obj === filtersItemsDeleted) {
            this.deleteSelectedFilter = { variable: key, value: obj };
            this._deleteSelectedItem(this.deleteSelectedFilter, filtersItemsDeleted);
          }
        }
      }
    }
  }

  queryJobMatches() {
    this.isFiltersChanged = false;
    this.showRefreshWorkFlowAction = false;
    this.refreshReRunScore = false;
    this.countOfCandidatesWhoseStepHasChangedInBackground = 0;
    this._createCandidatesObject();
    _.forEach(this.candidatesObject, (val: any) => {
      const tempWorkflowSteps = val.jobMatchesQueryFilter.workflowSteps;
      val.jobMatchesQueryFilter = _.cloneDeep(this.globalQueryFilterObject);
      val.jobMatchesQueryFilter.workflowSteps = tempWorkflowSteps;
      this._clearJobMatchIdsFilterOnAnyOtherFilterChange(val.jobMatchesQueryFilter);
      val.jobMatchesQueryFilter.workflowStates = val.jobMatchesQueryFilter.workflowStates.filter((state: any) => state);
      val.getNext();
    });
    if (this.selectAllJobMatchesFlag) {
      this.selectAllCandidates();
    }
    if (this.candidateWorkFlowFilterItemsSelected.length === 0) {
      this.displayCandidateWorkFlowFilter = false;
      this.showDisplayFilterIcon = true;
    }
    setTimeout(() => {
      this.stateManagementStorageService.setScreenState(`candidateWorkflowScreen-${this.userId}`, this.globalQueryFilterObject);
      this.stateManagementStorageService.setScreenState(`candidateWorkflowScreen-displayFilter-${this.userId}`, this.displaySelectedFilterContainer);
    }, 200);
  }

  resetWorkflowFilters() {
    this.isFiltersChanged = true;
    _.forEach(this.jobMatchStates, (val: any) => { val.ticked = false; });
    _.forEach(this.vendorsList, (val: any) => { val.ticked = false; });
    _.forEach(this.outreachFilters, (val: any) => { val.ticked = false; });
    this.selectedJobMatchStates = [];
    this.selectedVendors = [];
    this.selectedOutreachStates = [];
    setTimeout(() => {
      this.globalQueryFilterObject = new JobMatchesQueryFilter();
    }, 100);

    this.displaySelectedFilterContainer = { searchString: '', jobMatchStates: [], vendors: [], outreachStateFilters: [] };
    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
  }

  performActionMultiple(action: string) {
    let selectedCandidateJobMatches: any[] = [];
    if (this.selectAllJobMatchesFlag) {
      selectedCandidateJobMatches = _.cloneDeep(this.allJobMatches);
      const unSelectedCandidateJobMatches: any[] = [];
      _.forEach(this.candidatesObject, (val: any) => {
        _.forEach(val.candidates, (candidate: any) => {
          if (!candidate.selectedFlag) {
            unSelectedCandidateJobMatches.push(candidate);
          }
        });
      });
      _.forEach(unSelectedCandidateJobMatches, (unSelectedJobMatch: any) => {
        _.remove(selectedCandidateJobMatches, { jobMatchId: unSelectedJobMatch.jobMatchId });
      });
    } else {
      _.forEach(this.candidatesObject, (val: any) => {
        _.forEach(val.candidates, (candidate: any) => {
          if (candidate.selectedFlag) {
            selectedCandidateJobMatches.push(candidate);
          }
        });
      });
    }
    if (action === 'addCandidatesFromJobBoards' && !this.isJobBoardServiceUp) {
      this.alertsAndNotificationsService.showBannerMessage('Job Board Service is currently unavailable.', 'danger');
      return;
    }
    if (action === 'compareCandidates' && selectedCandidateJobMatches.length < 2) {
      this.alertsAndNotificationsService.showAlert('Too few Candidates Chosen', 'Please select at least two candidates to compare.', 'warning');
    } else if (action === 'compareCandidates' && selectedCandidateJobMatches.length > 3) {
      this.alertsAndNotificationsService.showAlert(`Too Many (${selectedCandidateJobMatches.length}) Candidates Chosen`, 'A maximum of 3 candidates can be compared at once. <br> Please choose 3 or fewer cards.', 'warning');
    } else if ((action === 'sendTechAssessment' || action === 'cancelTechAssessment' || action === 'sendValueAssessment' || action === 'cancelValueAssessment') && selectedCandidateJobMatches.length > 25) {
      let message = '';
      if (action === 'sendTechAssessment' || action === 'sendValueAssessment') {
        message = 'A maximum of 25 candidates can be sent an assessment at once. <br> Please choose 25 or fewer cards.';
      } else if (action === 'cancelTechAssessment' || action === 'cancelValueAssessment') {
        message = 'Assessment can be cancelled for a maximum of 25 candidates at once. <br> Please choose 25 or fewer cards.';
      }
      this.alertsAndNotificationsService.showAlert(`Too Many (${selectedCandidateJobMatches.length}) Candidates Chosen`, message, 'warning');
    } else if (action !== 'addCandidates' && action !== 'jobProfile' && action !== 'associateCandidates' && action !== 'compareCandidates' && action !== 'addCandidatesFromJobBoards' && selectedCandidateJobMatches.length === 0) {
      this.alertsAndNotificationsService.showAlert('No Cards Selected!', 'Please select at least one card to perform this action.', 'warning');
    } else if (action === 'sendCandidateOutreach' && selectedCandidateJobMatches.length > 0) {
      this._openSendOutreachEmailModal(selectedCandidateJobMatches);
    } else {
      this._openActionsModal(action, selectedCandidateJobMatches);
    }
  }

  private _openSendOutreachEmailModal(selectedCandidateJobMatches: any[]) {
    let windowClass = 'four-dot-five-modal-small';
    const validCandidatesToSendOutreachEmail: any[] = [];
    const notValidCandidatesToSendOutreachEmail: any[] = [];
    const selectedJobMatchesForOutreach: any[] = [];
    let isSingleCandidateSelected = false;
    let candidateId = '';
    let candidateType = '';
    selectedCandidateJobMatches.map((candidate: any) => {
      const candidateFirstName = candidate.firstName ? candidate.firstName + ' ' : '';
      const candidateLastName = candidate.lastName ? candidate.lastName : '';
      const tempObject: any = {};
      tempObject.jobMatchId = candidate.jobMatchId;
      tempObject.candidateId = candidate.id;
      tempObject.workflowStepName = candidate.currentStep;
      tempObject.candidateName = candidate.candidateName = candidateFirstName + candidateLastName;
      tempObject.message = '';
      tempObject.selected = true;
      tempObject.candidateType = candidate.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
      if (!candidate.email || (candidate.currentStep === 'Released' || candidate.currentStep === 'Not Interested') || candidate.isOutreachDisabled) {
        if (candidate.isOutreachDisabled) {
          tempObject.message = 'Outreach has already been Submitted.';
        } else if (candidate.currentStep === 'Released' || candidate.currentStep === 'Not Interested') {
          tempObject.message = `Cannot Send Outreach to Candidates in '${candidate.currentStep}' State.`;
        } else {
          tempObject.message = 'Email ID not available.';
        }
        notValidCandidatesToSendOutreachEmail.push(tempObject);
      } else {
        validCandidatesToSendOutreachEmail.push(tempObject);
        if (selectedCandidateJobMatches.length === 1) {
          selectedJobMatchesForOutreach.push({ ...candidate, ...tempObject });
        }
      }
    });
    isSingleCandidateSelected = selectedCandidateJobMatches.length === 1 && validCandidatesToSendOutreachEmail.length === 1;
    if (isSingleCandidateSelected) {
      selectedJobMatchesForOutreach[0].outreachActiveJob = true;
      selectedJobMatchesForOutreach[0].requisitionNumber = selectedJobMatchesForOutreach[0].jobMatchRequisitionNum;
      selectedJobMatchesForOutreach[0].jobTitle = selectedJobMatchesForOutreach[0].jobMatchTitle;
      selectedJobMatchesForOutreach[0].companyName = selectedJobMatchesForOutreach[0].clientOrBUName;
      selectedJobMatchesForOutreach[0].jobLocationText = this.jobMatchService.setJobLocationText(selectedJobMatchesForOutreach[0].jobLocation);
      selectedJobMatchesForOutreach[0].jobId = selectedJobMatchesForOutreach[0].jobMatchJobId;
      selectedJobMatchesForOutreach[0].candidateId = selectedJobMatchesForOutreach[0].id;
      windowClass = 'four-dot-five-modal-large';
      candidateId = selectedJobMatchesForOutreach[0].id;
      candidateType = selectedJobMatchesForOutreach[0].candidateType;
    }
    const label = isSingleCandidateSelected ? `Send outreach to Candidate <b>'${selectedJobMatchesForOutreach[0].candidateName}'</b>` : 'Send outreach to Candidates';

    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    let bsModalRef: BsModalRef;
    const config = new ModalConfig();
    config.class = 'custom-modal-xl custom-candidate-profile-modal';
    const resolve: any = {
      validCandidatesToSendOutreachEmail,
      notValidCandidatesToSendOutreachEmail,
      label,
      isSingleCandidateSelected,
      companyId: this.companyId,
      userId: this.userId,
      candidateId,
      clientOrBUId: this.jobInfo.clientOrBuId,
      candidateType,
      selectedJobMatchesForOutreach,
      context: 'candidateWorkflow',
      salaryDurationOptions: this.salaryDurationOptions,
      jobTypeList: this.jobTypeList,
      jobId: this.jobId,
      source: 'JOBMATCH_CARD'
    };
    config.initialState = {
      resolve,
      modalInstance: {
        close: (callbackObject: any) => {
          bsModalRef.hide();
          $('.modal').css('overflow-y', 'auto');
          if (callbackObject && callbackObject.callbackType === 'refresh') {
            this.resetCandidateJobMatches();
          }
        },
        dismiss: () => {
          bsModalRef.hide();
          $('.modal').css('overflow-y', 'auto');
        }
      }
    };
    bsModalRef = this.bsModalService.show(CandidateSendOutreachEmailModalComponent, config);
  }

  private _openActionsModal(action: string, selectedCandidateJobMatches: any[]) {
    let statusType = '';
    let windowTopClass = '';
    switch (action) {
      case 'release':
        windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
        statusType = 'Release';
        break;
      case 'notInterested':
        windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
        statusType = 'Not Interested';
        break;
      case 'delete':
        windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
        statusType = 'Delete Job Match';
        break;
      case 'addCandidates':
        windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
        break;
      case 'addCandidatesFromJobBoards':
        windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
        break;
      case 'associateCandidates':
        windowTopClass = 'custom-modal-2xl custom-candidate-job-match-modal';
        break;
      case 'sendTechAssessment':
        windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
        break;
      case 'cancelTechAssessment':
        windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
        break;
      case 'sendValueAssessment':
        windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
        break;
      case 'cancelValueAssessment':
        windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
        break;
      case 'compareCandidates':
        windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
        if (selectedCandidateJobMatches.length === 3) {
          windowTopClass = 'custom-modal-2xl custom-candidate-job-match-modal';
        }
        break;
      case 'jobProfile':
        windowTopClass = 'custom-modal-xl custom-candidate-job-match-modal';
        break;
      default:
        break;
    }
    const formalizeActivityPayload = {
      candidate: null,
      requisition: new FormalizeRequisition(this.jobId, this.jobInfo.requisitionActualNumber, this.jobInfo.requisitionRole),
      jobMatch: new FormalizeJobMatch(null, this.jobId, this.jobInfo.requisitionActualNumber, this.jobInfo.requisitionRole),
      company: new FormalizeCompany(this.companyId, this.jobInfo.companyName, this.jobInfo.clientOrBuId, this.jobInfo.clientName)
    };

    const jobMatchDetailsArray: any[] = [];
    _.forEach(selectedCandidateJobMatches, (val: any) => {
      jobMatchDetailsArray.push({
        jobMatchId: val.jobMatchId,
        candidateId: val.id,
        workflowStepName: val.currentStep
      });
    });

    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    let bsModalRef: BsModalRef;
    const config = new ModalConfig();
    config.class = windowTopClass;
    const resolve: any = {
      jobMatchDetailsArray,
      statusType,
      jobId: this.jobId,
      clientOrBuId: this.jobInfo.clientOrBuId,
      clientOrBuName: this.jobInfo.clientName,
      isSharedRequisition: this.jobInfo.sharedRequisition,
      corporateCompanyId: this.jobInfo.corporateId,
      corporateCompanyName: this.jobInfo.corporateName,
      lastAddedCandidateSourceTypeId: this.jobInfo.lastAddedCandidateSourceTypeId,
      action,
      resumeRequiredForWorkflow: this.jobInfo.resumeRequiredForWorkflow,
      formalizeActivityPayload
    };
    config.initialState = {
      resolve,
      modalInstance: {
        close: (callbackObject: any) => {
          bsModalRef.hide();
          $('.modal').css('overflow-y', 'auto');
          if (callbackObject && callbackObject.callbackType === 'refresh') {
            this.resetCandidateJobMatches();
          }
        },
        dismiss: () => {
          bsModalRef.hide();
          $('.modal').css('overflow-y', 'auto');
        }
      }
    };
    bsModalRef = this.bsModalService.show(CandidateJobMatchesWorkflowActionsModalComponent, config);
  }

  toggleColumn(workflowStep: any) {
    if (workflowStep.isCollapsedFlag) {
      workflowStep.isCollapsedFlag = false;
      setTimeout(() => {
        workflowStep.showCollapseIconFlag = true;
        workflowStep.expandCollapseLabel = 'Collapse Column';
        workflowStep.countAndLabelTooltipPlacement = 'bottom-right';
      }, 600);
    } else {
      workflowStep.isCollapsedFlag = true;
      setTimeout(() => {
        workflowStep.showCollapseIconFlag = false;
        workflowStep.expandCollapseLabel = 'Expand Column';
        workflowStep.countAndLabelTooltipPlacement = 'right';
      }, 600);
    }
  }

  onFilterItemClick(selectedItems: any, label: string) {
    this.isFiltersChanged = true;
    switch (label) {
      case 'JobMatchStates':
        this.globalQueryFilterObject.workflowStates = this.selectedJobMatchStates.map((val: any) => val.value);
        this.displaySelectedFilterContainer.jobMatchStates = this.globalQueryFilterObject.workflowStates;
        this.displaySelectedFilterContainer.jobMatchStates = this.displaySelectedFilterContainer.jobMatchStates.filter((val: any) => val !== undefined);
        this.displaySelectedFilterContainer.jobMatchStates = [...new Set(this.displaySelectedFilterContainer.jobMatchStates)];
        this.setSelectedFilterItems(this.displaySelectedFilterContainer);
        break;
      case 'Vendors':
        this.globalQueryFilterObject.vendors = this.selectedVendors.map((val: any) => val.vendorId);
        this.displaySelectedFilterContainer.vendors = this.selectedVendors.map((val: any) => val.vendorName);
        this.setSelectedFilterItems(this.displaySelectedFilterContainer);
        break;
      case 'OutreachStates':
        this.globalQueryFilterObject.outreachStateFilters = this.selectedOutreachStates.map((val: any) => val.value);
        this.displaySelectedFilterContainer.outreachStateFilters = this.selectedOutreachStates.map((val: any) => val.name);
        this.setSelectedFilterItems(this.displaySelectedFilterContainer);
        break;
      default:
      // do nothing
    }
  }

  filterSelectRemoveAll(label: string, type: string) {
    this.isFiltersChanged = true;
    if (type === 'selectAll') {
      switch (label) {
        case 'JobMatchStates':
          this.globalQueryFilterObject.workflowStates = this.jobMatchStates.map((val: any) => val.value);
          this.displaySelectedFilterContainer.jobMatchStates = this.globalQueryFilterObject.workflowStates;
          this.displaySelectedFilterContainer.jobMatchStates = this.displaySelectedFilterContainer.jobMatchStates.filter((val: any) => val !== undefined);
          this.displaySelectedFilterContainer.jobMatchStates = [...new Set(this.displaySelectedFilterContainer.jobMatchStates)];
          this.setSelectedFilterItems(this.displaySelectedFilterContainer);
          break;
        case 'Vendors':
          this.globalQueryFilterObject.vendors = this.vendorsList.map((val: any) => val.vendorId);
          this.displaySelectedFilterContainer.vendors = this.vendorsList.map((val: any) => val.vendorName);
          this.setSelectedFilterItems(this.displaySelectedFilterContainer);
          break;
        case 'OutreachStates':
          this.globalQueryFilterObject.outreachStateFilters = this.outreachFilters.map((val: any) => val.value);
          this.displaySelectedFilterContainer.outreachStateFilters = this.outreachFilters.map((val: any) => val.name);
          this.setSelectedFilterItems(this.displaySelectedFilterContainer);
          break;
        default:
        // do nothing
      }
    } else {
      switch (label) {
        case 'JobMatchStates':
          this.globalQueryFilterObject.workflowStates = [];
          this.displaySelectedFilterContainer.jobMatchStates = [];
          this.setSelectedFilterItems(this.displaySelectedFilterContainer);
          break;
        case 'Vendors':
          this.globalQueryFilterObject.vendors = [];
          this.displaySelectedFilterContainer.vendors = [];
          this.setSelectedFilterItems(this.displaySelectedFilterContainer);
          break;
        case 'OutreachStates':
          this.globalQueryFilterObject.outreachStateFilters = [];
          this.displaySelectedFilterContainer.outreachStateFilters = [];
          this.setSelectedFilterItems(this.displaySelectedFilterContainer);
          break;
        default:
        // do nothing
      }
    }
  }

  dropJobMatchCardCallback(draggableCandidate: any, droppingToStep: any) {
    this.jobMatchDragAndDropService.dropJobMatchCardToWorkflowStep(draggableCandidate, droppingToStep, this.workflowStepNames, () => {
      this.resetCandidateJobMatches();
    });
  }

  /** Used with the keyvalue pipe to keep candidatesObject's natural (insertion) order instead of sorting by key. */
  keepOriginalOrder = () => 0;

  // ng-select's built-in ng-multi-label-tmp extension point: collapses the closed
  // control to "First selection (N)" instead of stacking every chip, per selection.
  getMultiSelectSummary(items: any[], bindLabel: string): string {
    if (!items || items.length === 0) { return ''; }
    const firstLabel = items[0][bindLabel];
    return items.length > 1 ? `${firstLabel} ... (${items.length})` : firstLabel;
  }

  get dropListIds(): string[] {
    return Object.values(this.candidatesObject).map((step: any) => step.uiIdentifier);
  }

  onCdkDrop(event: any, workflowStep: any) {
    const draggableCandidate = event.item.data;
    this.dropJobMatchCardCallback(draggableCandidate, workflowStep.workflowStep);
  }

  onDragStart(jobMatchToDrop: any) {
    if (this.jobMatchDragAndDropService.isMoveBackActionFromNotInterestedOrReleasedStep(jobMatchToDrop)) {
      const currentStep = jobMatchToDrop.currentStep;
      const stepToDropTo = jobMatchToDrop.availableActions.filter((action: any) => action.actionType === 'MOVE_BACKWARD');
      this._removeDisallowedTypesFromSteps(currentStep, stepToDropTo[0]);
    }
  }

  private _removeDisallowedTypesFromSteps(currentStepName: any, stepToDropTo: any) {
    const stepToDropToName = stepToDropTo.action.replace('Move back to ', '');
    _.forEach(this.candidatesObject, (step: any) => {
      if (step.workflowStep !== 'Not Interested' && step.workflowStep !== 'Released' && step.workflowStep !== stepToDropToName) {
        step.allowedDnDTypes = step.allowedDnDTypes.filter((type: any) => type !== currentStepName);
      }
    });
  }

  onDragEnd(jobMatchToDrop: any) {
    if (this.jobMatchDragAndDropService.isMoveBackActionFromNotInterestedOrReleasedStep(jobMatchToDrop)) {
      this._resetAllowedDndTypes();
    }
  }

  private _resetAllowedDndTypes() {
    _.forEach(this.candidatesObject, (workflowStep: any) => {
      workflowStep.allowedDnDTypes = [...this.jobMatchDragAndDropService.getAllowedDraggableTypesOfCurrentWorkflowStep(workflowStep.workflowStep, this.workflowStepNames)];
    });
  }

  /**
   * Called by Angular CDK's cdkDropListEnterPredicate to restrict which columns
   * a dragged card may be dropped into - mirrors the legacy dnd-allowed-types check.
   */
  canDropInStep(workflowStep: any) {
    return (drag: any) => {
      const draggedCandidate = drag.data;
      return workflowStep.allowedDnDTypes && workflowStep.allowedDnDTypes.indexOf(draggedCandidate.currentStep) !== -1;
    };
  }

  getOutreachFilters() {
    this.outreachFiltersLoadedFlag = false;
    this.outreachService.getOutreachFilters((data: any) => {
      this.outreachFilters = data;
      if (this.savedFilters && this.savedFilters.outreachStateFilters && this.savedFilters.outreachStateFilters.length > 0) {
        this.selectedOutreachStates = this.outreachFilters.filter(outreach => this.savedFilters.outreachStateFilters.some((selected: any) => selected === outreach.value));
        this.selectedOutreachStates.forEach(selected => { selected.ticked = true; });
        this.globalQueryFilterObject.outreachStateFilters = this.selectedOutreachStates.map((val: any) => val.value);
      }

      if (this.savedDisplayedWorkflowSelectedFilter && this.savedDisplayedWorkflowSelectedFilter.outreachStateFilters && this.savedDisplayedWorkflowSelectedFilter.outreachStateFilters.length !== 0) {
        this.displaySelectedFilterContainer.outreachStateFilters = [];
        this.displaySelectedFilterContainer.outreachStateFilters = this.selectedOutreachStates.map((val: any) => val.name);
        this.setSelectedFilterItems(this.displaySelectedFilterContainer);
      }

      this.outreachFiltersLoadedFlag = true;
    }, (error: any) => {
      this.outreachFiltersLoadedFlag = true;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  ngOnDestroy() {
    this.webSocketsService.resetWorkflowUpdateListener();
    if (this.workflowUpdateSubscription) {
      this.workflowUpdateSubscription.unsubscribe();
    }
    if (this.refreshJobWorkflowSubscription) {
      this.refreshJobWorkflowSubscription.unsubscribe();
    }
    if (this.removeJobMatchSubscription) {
      this.removeJobMatchSubscription.unsubscribe();
    }
  }
}
